import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import Notification from './components/Notification';

const el = document.createElement('div');
document.body.appendChild(el);

const notificationRef = createRef();

const root = createRoot(el);
root.render(<Notification ref={notificationRef} />);

const showMessage = (...args) => notificationRef.current?.showMessage(...args);
const hideMessage = (...args) => notificationRef.current?.hideMessage(...args);
const updateMessageText = (...args) => notificationRef.current?.updateMessageText(...args);

export { showMessage, hideMessage, updateMessageText };